import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    currentSlide: 0,
    desktopCarouselChangedCurrentSlide: false,
    fullscreenCarouselChangedCurrentSlide: false,
  },
  actions: {
  },
  mutations: {
    currentSlide(state, payload) {
        state.currentSlide = payload;
    },
    desktopCarouselChangedCurrentSlide(state, payload) {
        state.desktopCarouselChangedCurrentSlide = payload;
    },
    fullscreenCarouselChangedCurrentSlide(state, payload) {
        state.fullscreenCarouselChangedCurrentSlide = payload;
    },
  },
};
